import { useState, useEffect, useCallback } from 'react';
import { SWORN_DATA } from '../../gameData';

export const useAppModals = (userId?: string | null, showSplash?: boolean) => {
    // Core Modals
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showLoadModal, setShowLoadModal] = useState(false);
    const [showKnightModal, setShowKnightModal] = useState(false);
    const [showLoadoutModal, setShowLoadoutModal] = useState(false);
    const [showCompendiumKnightModal, setShowCompendiumKnightModal] = useState(false);
    const [showCompendiumFaeModal, setShowCompendiumFaeModal] = useState(false);
    const [showCommunityModal, setShowCommunityModal] = useState(false);
    const [saveMode, setSaveMode] = useState<'update' | 'new' | 'rename'>('update');

    // Share State
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareLink, setShareLink] = useState('');
    const [showShareConfirmModal, setShowShareConfirmModal] = useState(false);
    const [pendingShare, setPendingShare] = useState(false);

    // Tutorial State
    const [showTutorial, setShowTutorial] = useState(false);

    // Admin State
    const [showAdminPanel, setShowAdminPanel] = useState(false);
    const [showAdminLogin, setShowAdminLogin] = useState(false);
    const [adminPasswordInput, setAdminPasswordInput] = useState('');

    // Check URL params for Admin Trigger
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const adminParam = SWORN_DATA.admin_config?.url_param || 'admin';
        if (params.get(adminParam) === 'true') {
            setShowAdminLogin(true);
        }
    }, [userId]);

    // Check Tutorial
    useEffect(() => {
        const hasSeenTutorial = localStorage.getItem('sworn_builder_tutorial_seen');
        if (!hasSeenTutorial && !showSplash) {
            const timer = setTimeout(() => setShowTutorial(true), 1500);
            return () => clearTimeout(timer);
        }
    }, [showSplash]);

    const handleCloseTutorial = useCallback(() => {
        setShowTutorial(false);
        localStorage.setItem('sworn_builder_tutorial_seen', 'true');
    }, []);

    const handleAdminLogin = useCallback(() => {
        // Simple client-side password check ("Security for show")
        // The REAL security is in firestore.rules whitelisting the UID.
        const accessCode = SWORN_DATA.admin_config?.access_code || 'arthur123';
        if (adminPasswordInput === accessCode) { 
            setShowAdminLogin(false);
            setShowAdminPanel(true);
        } else {
            alert("Access Denied");
        }
    }, [adminPasswordInput]);

    return {
        // Core
        showSaveModal, setShowSaveModal,
        showLoadModal, setShowLoadModal,
        showKnightModal, setShowKnightModal,
        showLoadoutModal, setShowLoadoutModal,
        showCompendiumKnightModal, setShowCompendiumKnightModal,
        showCompendiumFaeModal, setShowCompendiumFaeModal,
        showCommunityModal, setShowCommunityModal,
        saveMode, setSaveMode,
        
        // Share
        showShareModal, setShowShareModal,
        shareLink, setShareLink,
        showShareConfirmModal, setShowShareConfirmModal,
        pendingShare, setPendingShare,

        // Tutorial
        showTutorial, setShowTutorial,
        handleCloseTutorial,

        // Admin
        showAdminPanel, setShowAdminPanel,
        showAdminLogin, setShowAdminLogin,
        adminPasswordInput, setAdminPasswordInput,
        handleAdminLogin
    };
};
